import axios from "axios";

export const useBackEvolution = () => {

	const instance = axios.create({
		baseURL: '/evolution',
		headers: {
			"Content-Type": "application/json",
		}
	});

	instance.interceptors.request.use(
		(config) => {
			config.headers.apikey = `MKDIREVOLUTION_0603`;
			return config;
		},
		(error) => {
			return Promise.reject(error);
		}
	);

	return instance;
};